import type {ConnectElementConfig} from '../../../connect/ConnectJSInterface/ConnectElementList';

export const financialAccountParameter = 'financial-account' as const;
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const financialAccountParams = [financialAccountParameter] as const;

type FinancialAccountParams = (typeof financialAccountParams)[number];
export type FinancialAccountHtmlParams = Partial<
  Record<FinancialAccountParams, string>
>;

export const FinancialAccountConfig: ConnectElementConfig = {
  Component: () =>
    import(
      /* webpackChunkName: "treasuryFinancialAccount" */
      '../../../components/Treasury/FinancialAccount'
    ),
  htmlAttributes: {
    [financialAccountParameter]: {
      isInternal: false,
    },
  },
  customHtmlElementMethods: {
    setFinancialAccount: {
      type: 'AttributeSettingMethod',
      attribute: financialAccountParameter,
      isInternal: false,
      description:
        'Sets the financial account id to display balance and money movement options for.',
    },
  },
  releaseState: 'ga',
  sentryTeam: 'treasury_surfaces',
  teamOwner: 'baas-growth',
  description:
    'Displays balance and money movement options for the given financial account.',
  friendlyName: 'Financial account',
  docSitePath: '/connect/supported-embedded-components/financial-account',
  syntheticTestInfo: {
    testUrl:
      'https://amp.corp.stripe.com/synthetics/us-west-2/sus-financial-acct-rc',
    rcTestUrl:
      'https://amp.corp.stripe.com/synthetics/us-west-2/sus-financial-acct-rc',
  },
};
